<template>
  <div>
    <footer class="main-footer mobile-footer">
      <div class="float-chat d-none">
        <a
          href="javascript:void(0);"
          @click.prevent="goToChat"
          class="float-chat-btn fas fa-comment-dots"
        ></a>
      </div>
      <div class="d-none d-sm-block">
        <strong
          >{{ new Date().getFullYear() }} &copy;
          <a href="javascript:void(0)">Audra Solutions Ltd.</a>.</strong
        >
        All rights reserved.
      </div>
      <div class="d-block d-sm-none">
        <nav class="mobile-nav-bar">
          <ul>
            <li
              @click="activate(li.id)"
              :class="{ active: active_el == li.id }"
              v-for="(li, index) in menu_list"
              :key="index"
            >
              <router-link :to="li.route"
                ><i :class="li.icon"></i> {{ li.menu }}</router-link
              >
            </li>
            <li class="d-none">
              <a
                target="_blank"
                href="javascript:void(0);"
                @click.prevent="goToChat"
              >
                <i class="fas fa-comment-dots"></i> Chat</a
              >
            </li>
            <li :class="{ open: show }">
              <a
                class="hamburger-icon"
                href="javascripit:void(0);"
                @click="show = !show"
              >
                <i class="far fa-user-circle"></i> Profile</a
              >
            </li>
            <div class="indicator"></div>
          </ul>
        </nav>
      </div>
    </footer>
    <nav class="mobile-menu d-block d-sm-none">
      <h3>
        Profile
        <a class="hamburger-icon fas fa-times" href="javascripit:void(0);"></a>
      </h3>
      <div class="profile-info-list">
        <ul>
          <li>
            <div>
              <img src="../../../public/assets/images/icon-user.svg" alt="" />
            </div>
            <!-- {{ accountInfo }} -->
            <h4>
              Account holder <span>{{ accountInfo.username }}</span>
            </h4>
          </li>
          <li>
            <div>
              <img
                src="../../../public/assets/images/icon-package.svg"
                alt=""
              />
            </div>
            <h4>
              Current package <span>{{ packageInfo.package }}</span>
            </h4>
          </li>
          <li>
            <div>
              <img src="../../../public/assets/images/icon-time.svg" alt="" />
            </div>
            <h4>
              Contract start date
              <span>{{
                packageInfo.contractStartDate
                  ? packageInfo.contractStartDate
                  : "NA"
              }}</span>
            </h4>
          </li>
          <li>
            <div>
              <img src="../../../public/assets/images/icon-user.svg" alt="" />
            </div>
            <h4>
              Contact number <span>{{ accountInfo.phone }}</span>
            </h4>
          </li>
          <li>
            <div>
              <img src="../../../public/assets/images/icon-mail.svg" alt="" />
            </div>
            <h4>
              Email address <span> {{ accountInfo.email }}</span>
            </h4>
          </li>
        </ul>
      </div>
      <ul class="d-none">
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link">
            <span>
              Your connections <i class="right fas fa-angle-right"></i
            ></span>
          </a>
          <ul class="nav__sub connection-mobile">
            <li class="nav__item">
              <a href="#">
                <div class="connection-avatar">
                  <i class="fas fa-user"></i>
                </div>
                <h4>Client ID: 226546 <span>Lalmatia 3</span></h4>
              </a>
            </li>
            <li class="nav__item">
              <a href="#">
                <div class="connection-avatar">
                  <i class="fas fa-user"></i>
                </div>
                <h4>Client ID: 226546 <span>Lalmatia</span></h4>
              </a>
            </li>
            <li class="nav__item">
              <a href="#">
                <div class="connection-avatar">
                  <i class="fas fa-user"></i>
                </div>
                <h4>Client ID: 226546 <span>Lalmatia</span></h4>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav__item"
          v-for="(item, index) in menuItems"
          v-if="!ignore_route.includes(item.title)"
        >
          <router-link
            v-if="!_.isEmpty(item.uri) && _.isEmpty(item.children)"
            :to="'/admin/' + (item.uri == '/' ? '' : item.uri)"
            class="nav__link"
          >
            <i
              v-if="!_.isEmpty(item.icon)"
              class="nav-icon fas"
              v-bind:class="item.icon"
            ></i>
            <i v-else class="far fa-circle nav-icon"></i>
            <span>
              {{ item.title }}
              <i
                v-if="!_.isEmpty(item.children)"
                class="right fas fa-angle-right"
              ></i>
            </span>
          </router-link>
          <a v-else href="javascript:void(0)" class="nav__link">
            <i
              v-if="!_.isEmpty(item.icon)"
              class="nav-icon fas"
              v-bind:class="item.icon"
            ></i>
            <i v-else class="nav-icon fas fa-circle"></i>
            <span>
              {{ item.title }}
              <i
                v-if="!_.isEmpty(item.children)"
                class="right fas fa-angle-right"
              ></i>
            </span>
          </a>
          <ul class="nav__sub" v-if="!_.isEmpty(item.children)">
            <li
              class="nav__item"
              v-for="(itemChild, childIndex) in item.children"
              v-if="!ignore_route.includes(itemChild.title)"
            >
              <router-link
                v-if="!_.isEmpty(itemChild.uri)"
                :to="'/admin/' + itemChild.uri"
                class="nav__link"
              >
                <i
                  v-if="!_.isEmpty(itemChild.icon)"
                  class="fas nav-icon"
                  v-bind:class="itemChild.icon"
                ></i>
                <i v-else class="far fa-circle nav-icon"></i>
                <span>{{ itemChild.title }}</span>
              </router-link>
              <a v-else href="javascript:void(0)" class="nav__item">
                <i
                  v-if="!_.isEmpty(itemChild.icon)"
                  class="nav-icon fas"
                  v-bind:class="itemChild.icon"
                ></i>
                <i v-else class="nav-icon fas fa-circle"></i>
                <span>
                  {{ itemChild.title }}
                  <i
                    v-if="!_.isEmpty(itemChild.children)"
                    class="right fas fa-angle-right"
                  ></i>
                </span>
              </a>
              <ul class="nav__sub" v-if="!_.isEmpty(itemChild.children)">
                <li
                  class="nav__item"
                  v-for="(
                    itemGrandChild, grandChildIndex
                  ) in itemChild.children"
                >
                  <router-link
                    v-if="!_.isEmpty(itemGrandChild.uri)"
                    :to="'/admin/' + itemGrandChild.uri"
                    class="nav__link"
                  >
                    <i
                      v-if="!_.isEmpty(itemGrandChild.icon)"
                      class="fas nav-icon"
                      v-bind:class="itemGrandChild.icon"
                    ></i>
                    <i v-else class="far fa-dot-circle nav-icon"></i>
                    <span>{{ itemGrandChild.title }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>
<style></style>
<script>
import $ from "jquery";
import { CommonAPI, Menu } from "@/services/api";
import { mapGetters, mapActions } from "vuex";
import { Cordova } from "@awesome-cordova-plugins/core";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Capacitor } from "@capacitor/core";
// import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    //
  },
  data: () => ({
    menu_list: [
      { id: "1", menu: "Home", icon: "fas fa-home", route: "/admin/dashboard" },
      // {
      //   id: "2",
      //   menu: "Pay Bill",
      //   icon: "fas fa-money-check",
      //   route: "/admin/paybill",
      // },
      {
        id: "2",
        menu: "Support",
        icon: "fas fa-headphones",
        route: "/admin/support-ticket",
      },
      // {
      //   id: "3",
      //   menu: "Chat",
      //   icon: "fas fa-comment-dots",
      //   route: "https://astpp.dotlines.com.sg/chat_customer/vicidial_chat_customer_side.php",
      // }
    ],
    active_el: 0,
    show: false,
    showChild: false,
    showMobileMenu: false,
    curretMenuName: "Back",
    chatLink:
      "https://cc.carnivalinternet.co.uk/chat_customer/vicidial_chat_customer_side.php",
    menuItems: [],
    user_detail: {},
    ignore_route: [],
  }),
  computed: {
    ...mapGetters(["profile", "accountInfo", "packageInfo"]),
  },
  async mounted() {
    window.scrollTo(0, 0);

    if (_.isEmpty(this.profile)) {
      await CommonAPI.getProfile().then((profile_info) => {
        this.user_detail = profile_info;
        // console.log(profile_info);
      });
    } else {
      this.user_detail = this.profile;
    }

    if (_.isEmpty(this.accountInfo)) {
      this.FETCH_ACCOUNT_INFO();
    }

    if (_.isEmpty(this.packageInfo)) {
      this.FETCH_PACKAGE_INFO();
    }

    if (this.isMobile()) {
      this.ignore_route = [
        "Helpers",
        "Product Management",
        "Templates Settings",
        "Database Connections",
        "Manage Services",
        "Manage CSS Class",
        "Transaction Logs",
        "Redis Manager",
        "Manage Box Style",
        "Table Options",
        "Manage Form Setting",
        "Chat",
        "Charging & Billing",
        "Form Management",
        "Report Builder",
        "Custom Permission",
        "Project Planning",
        "Resource Requisition Workflow",
        "Subscribe to Medical Wallet",
        "Inventory",
        "Procurement Management",
        "Requisition",
        "Requisition  Master",
        "Update Password",
        "Log viewer",
        "Table Operation Logs",
        "Attendance Individual Mail DND List",
        "Attendence Daily Report",
        "DND List",
        "Project Planning",
        "Attendance Individual Mail DND",
        "Attendance Report",
        "Open Kanban",
      ];
    } else {
      if (
        this.user_detail.roles[0].id === 1 ||
        this.user_detail.roles[0].id === 3 ||
        this.user_detail.roles[0].id === 4
      ) {
        // console.log('ignore route for ppf user');
        this.ignore_route = [
          "Product Management",
          "Templates Settings",
          "Database Connections",
          "Manage Services",
          "Manage CSS Class",
          "Transaction Logs",
          "Redis Manager",
          "Manage Box Style",
          "Table Options",
          "Manage Form Setting",
          "Chat",
          "Charging & Billing",
          "Form Management",
          "Report Builder",
          "Custom Permission",
          "Project Planning",
          "Resource Requisition Workflow",
          "Subscribe to Medical Wallet",
          "Inventory",
          "Procurement Management",
          "Requisition",
          "Requisition  Master",
          "Update Password",
          "Log viewer",
          "Table Operation Logs",
          "Attendance Individual Mail DND List",
          "Attendence Daily Report",
          "DND List",
          "Project Planning",
          "Attendance Individual Mail DND",
          "Attendance Report",
        ];
      } else {
        // console.log('ignore route for normal user');

        this.ignore_route = [
          "Product Management",
          "Templates Settings",
          "Database Connections",
          "Manage Services",
          "Manage CSS Class",
          "Transaction Logs",
          "Redis Manager",
          "Manage Box Style",
          "Table Options",
          "Manage Form Setting",
          "Chat",
          "Charging & Billing",
          "Form Management",
          "Report Builder",
          "Custom Permission",
          "Project Planning",
          "Resource Requisition Workflow",
          "Subscribe to Medical Wallet",
          "Inventory",
          "Procurement Management",
          "Requisition",
          "Requisition  Master",
          "Update Password",
          "Log viewer",
          "Table Operation Logs",
          "Attendance Individual Mail DND List",
          "Attendence Daily Report",
          "DND List",
          "Project Planning",
          "Attendance Individual Mail DND",
          "Attendance Report",
          "Form List",
          "PPF",
        ];
      }
    }
    // $(window).trigger("resize");

    // // window.$('ul[data-widget="treeview"]').Treeview("init");
    await this.getMenuItems();
	//this.checkAndLoadScript();
    //setInterval(this.checkAndLoadScript, 60000); // Check every minute
  },
  methods: {
    ...mapActions([
      "FETCH_PROFILE",
      "FETCH_ACCOUNT_INFO",
      "FETCH_PACKAGE_INFO",
    ]),
	/*checkAndLoadScript() {
      const now = new Date();
      const hours = now.getHours();

      if (hours >= 9 && hours < 17) { 
        this.loadScript();
      }
    },
	loadScript() {
		var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
		var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
		s1.async=true;
		s1.src='https://embed.tawk.to/67a0925c3a842732607901c3/1ij5jnf7d';
		s1.charset='UTF-8';
		s1.setAttribute('crossorigin','*');
		s0.parentNode.insertBefore(s1,s0);
		// Set visitor attributes   
		Tawk_API.onLoad = function() {
			Tawk_API.setAttributes({
				'name': 'Customer Name',
				'email': 'customer@example.com',
				'phone': '123-456-7890',
				'customer_id': 'CUSTOMER_ID'
			}, 
			function(error) {
				if (error) { console.error('Error setting attributes:', error);}       
			});   
		};
    },*/
    goToChat: function () {
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      // console.log("Subscriber:::", subscriber);
      // first_name, last_name, mobile_no
      let firstName = encodeURIComponent(subscriber.first_name);
      let lastName = encodeURIComponent(subscriber.last_name);
      let mobileNo = encodeURIComponent(subscriber.contact);
      const redirectUrl = `${this.chatLink}?first_name=${firstName}&last_name=${lastName}&phone_number=${mobileNo}`;
      if (!Capacitor.isNativePlatform()) {
        // window.location.href = redirectUrl;
        window.open(redirectUrl, "_blank");
        return false;
      } else {
        // @ts-ignore
        let ref = cordova.InAppBrowser.open(
          redirectUrl,
          "_blank",
          "location=yes,hideurlbar=yes"
        );

        let myCallback = function (event) {
          console.log("Updated URL: ", event.url);
        };
        ref.addEventListener("loadstart", myCallback);
      }
    },

    getMenuItems: function () {
      Menu.getAllMenus()
        .then((menus) => {
          console.log(menus);
          this.menuItems = menus;
        })
        .catch((e) => {
          console.log("errrr", e);
        })
        .finally(() => {
          this.menuItemjs();
        });
    },
    activate: function (el) {
      this.active_el = el;
    },

    menuItemjs: function () {
      // setTimeout(function () {
      let _this = this;
      // $('.nav__sub').prepend('<li class="nav__item"><a class="nav__link sub__close" href="javascript:void(0)"><i class="fas fa-chevron-left"></i>' + (_this.curretMenuName === undefined) ? 'Back' : _this.curretMenuName + '</a></li>');
      $(".nav__sub").prepend(
        '<li class="nav__item"><a class="nav__link sub__close" href="javascript:void(0)"><i class="fas fa-chevron-left"></i>' +
          _this.curretMenuName +
          "</a></li>"
      );

      $(".sub__close").click(function (e) {
        console.log("closing");
        e.preventDefault();
        $(this).parent().parent().removeClass("is-active");
      });

      $(".nav__link").click(function (e) {
        e.preventDefault();
        $(this).siblings().addClass("is-active");
      });

      $(".mobile-menu ul .nav__item a[href!='javascript:void(0)']").on(
        "click",
        function (e) {
          // console.log('closing in sub');
          $(".mobile-menu").removeClass("is-open");
          $(".mobile-nav-bar ul li").removeClass("active");
          $(".nav__sub").removeClass("is-active");
          e.preventDefault();
        }
      );

      $(".hamburger-icon").on("click", function (e) {
        $(".mobile-menu").toggleClass("is-open");
        e.preventDefault();
      });

      // }, 1000);
    },
  },

  // async created() {
  //
  //
  //
  // }
};
</script>
